import React, { Component, Suspense } from 'react';
class SuspenseWithErrorBoundary extends Component {
  state = {
    // optional second annotation for better type inference
    hasError: false
  };
  static getDerivedStateFromError(_error) {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true
    };
  }
  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    if (this.props.onError) {
      this.props.onError(error, errorInfo);
    }
  }
  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return this.props.error || null;
    }
    return /*#__PURE__*/React.createElement(Suspense, {
      fallback: this.props.fallback || null
    }, this.props.children);
  }
}
export default SuspenseWithErrorBoundary;
//# sourceMappingURL=SuspenseWithErrorBoundary.js.map